import { Column, IColumnProps } from "devextreme-react/data-grid";
import { Item, IItemProps } from "devextreme-react/form";

export const getDataGridEditorFormItems = (
  rowData: any,
  colCount: number,
  colSpan: number,
  editorItemOptions?: Map<string, IItemProps>,
  keyColumns?: string[],
  isEditing?: boolean,
  isKeyAutoGenerated?: boolean,
  columnConfigs?: Map<string, IColumnProps>,
) => {
  const items = [];
  const keyColumnsSet = keyColumns ? new Set(keyColumns) : null;

  // Order the form fields to follow the column config order (so the form matches the grid),
  // then append any remaining fields present in the row data but not in the config.
  const orderedKeys: string[] = [];
  const seen = new Set<string>();
  if (columnConfigs) {
    columnConfigs.forEach((_value, key) => {
      if (key in rowData && !seen.has(key)) {
        orderedKeys.push(key);
        seen.add(key);
      }
    });
  }
  for (const key in rowData) {
    if (!seen.has(key)) {
      orderedKeys.push(key);
      seen.add(key);
    }
  }

  for (const key of orderedKeys) {
    const itemProps = editorItemOptions?.get(key) || {};
    const isKeyColumn = keyColumnsSet?.has(key);
    const shouldBeReadOnly = isKeyColumn && (isEditing || isKeyAutoGenerated);
    // readOnly must always be set: DevExtreme deep-merges editorOptions, so an omitted
    // key keeps the previous value and the edit-mode lock would leak into add mode.
    const editorOptions = {
      ...itemProps.editorOptions,
      readOnly: shouldBeReadOnly || itemProps.editorOptions?.readOnly === true,
    };
    items.push(
      <Item 
        key={key} 
        dataField={key} 
        {...itemProps}
        editorOptions={editorOptions}
      />
    );
  }
  return (
    <Item itemType="group" colCount={colCount} colSpan={colSpan}>
      {items}
    </Item>
  );
};

export const getDataGridColumns = (
  rowData: any,
  keyColumns: string[],
  excludeKeyColumns?: boolean,
  columnConfigs?: Map<string, IColumnProps>,
  excludedColumns?: Set<string>,
) => {
  const columns = [];
  const keyColumnsSet = excludeKeyColumns ? new Set(keyColumns) : null;
  
  if (columnConfigs) {
    columnConfigs.forEach((value, key) => {
      if ((!keyColumnsSet || !keyColumnsSet.has(key)) && 
          (!excludedColumns || !excludedColumns.has(key))) {
        columns.push(<Column key={key} {...value} />);
      }
    });
  }
  for (const key in rowData) {
    if (!columnConfigs || !columnConfigs.has(key)) {
      if ((!keyColumnsSet || !keyColumnsSet.has(key)) && 
          (!excludedColumns || !excludedColumns.has(key))) {
        columns.push(<Column key={key} dataField={key} />);
      }
    }
  }
  return columns;
};
